import { Component } from '@inter-ikea-core/core';

/**
 * Added to entites affected by hiding/showing doors (fronts and children to fronts).
 */
export default class ToggleDoorsComponent implements Component {
  static id = 2068;
  typeId = ToggleDoorsComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;
  doorsHidden: boolean;

  constructor(doorsHidden: boolean) {
    this.doorsHidden = doorsHidden;
  }

  eq(other: ToggleDoorsComponent) {
    return this.doorsHidden === other.doorsHidden;
  }
}
